<template>
  <div class="info_wrapper">
    <p class="typo-big">Candy Codes is a project by Moniker<br>commissioned by MU Eindhoven.
      <br /><br />
      Credits:<br>
      Concept & Production: <a href="https://www.studiomoniker.com/" target="_blank" alt="Studio Moniker">Moniker</a><br>
      Actor: Kato Wouters<br>
      Typefaces: Lars Mono by <a href="https://www.bold-decisions.biz/" target="_blank" alt="Bold Decisions">Bold Decisions</a>,<br>
      Joe182 by <a href="http://heavyweight.cz/" target="_blank" alt="Heavyweight">Heavyweight</a>
    </p>
    <button class="button back-button top right" @click="hideInfo">x</button>
  </div>
</template>

<script>

export default {
  name: 'Info',
  methods: {
    hideInfo() {
      this.$eventHub.$emit('toggleInfo')
    },
  },
}
</script>

<style lang="scss">

@mixin small {
  @media (max-width: 320px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1300px) {
    @content;
  }
}

.info_wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background: black;
  padding: 15px 100px 50px 40px;

  @include tablet {
    padding: 32px 130px 60px 58px;
  }

  @include desktop {
    padding: 37px 130px 60px 58px;
  }

  button {
    margin-top: -4px;
    margin-right: -2px;

    @include tablet {
      margin-top: -4px;
      font-size: 50px;
    }

    @include desktop {
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Info.vue